import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import AttendanceViewModel from "./AttendanceViewModel";

const Attendance = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    ClassID,
    CourseID,
    SubjectAttendance,
    IsAttendanceTaken,
    AuthUser,
  } = AttendanceViewModel();

  const [DateFilter, setDateFilter] = useState("");
  const [MonthFilter, setMonthFilter] = useState("");

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Attendance</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Attendance</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Date ..."
                    onChange={(e) => {
                      setDateFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Month ..."
                    onChange={(e) => {
                      setMonthFilter(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Attendance</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        {IsAttendanceTaken ? (
                          <button disabled className="btn btn-primary">
                            Attendance Taken
                          </button>
                        ) : (
                          (AuthUser?.UserType === "admin" ||
                            AuthUser?.UserType === "teacher") && (
                            <Link
                              className={`btn btn-primary`}
                              to={`/user/${AuthUser?.UserType}/classes/courses/attendance/add/${ClassID}/${CourseID}`}
                            >
                              <i className="fas fa-plus" />
                            </Link>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                    <thead className="student-thread">
                      <tr>
                        <th>Date</th>
                        <th>Present Students</th>
                        <th>Absent Students</th>

                        <th className="text-end">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {SubjectAttendance &&
                        SubjectAttendance.filter(
                          (item) =>
                            DateFilter === "" ||
                            (item.AttendanceDate.toDate().getDate() ===
                              new Date(DateFilter).getDate() &&
                              item.AttendanceDate.toDate().getMonth() ===
                                new Date(DateFilter).getMonth() &&
                              item.AttendanceDate.toDate().getFullYear() ===
                                new Date(DateFilter).getFullYear())
                        )
                          .filter(
                            (item) =>
                              MonthFilter === "" ||
                              item.AttendanceDate.toDate()
                                .toLocaleString("default", { month: "long" })
                                .toLowerCase()
                                .includes(MonthFilter.toLowerCase())
                          )
                          .map((item, index) => {
                            const { AttendanceDate, Students } = item;

                            let TotPresent = 0;
                            let TotAbsent = 0;
                            {
                              Students.map((std) =>
                                std.IsPresent ? TotPresent++ : TotAbsent++
                              );
                            }
                            return (
                              <tr key={index}>
                                <td>
                                  {AttendanceDate.toDate().toLocaleString(
                                    "en-GB",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    }
                                  )}
                                </td>
                                <td>{TotPresent}</td>
                                <td>{TotAbsent}</td>

                                <td className="text-end">
                                  <div className="actions">
                                    {(AuthUser?.UserType === "admin" ||
                                      AuthUser?.UserType === "teacher") && (
                                      <>
                                        <Link
                                          onClick={() => {
                                            handleOpenDeleteDialog(item.id);
                                          }}
                                          className="btn btn-sm bg-success-light me-2"
                                        >
                                          <i className="fa-regular fa-trash-can"></i>
                                        </Link>
                                      </>
                                    )}
                                    <Link
                                      to={`/user/${AuthUser?.UserType}/classes/courses/attendance/details?docId=${item.id}`}
                                      className="btn btn-sm bg-danger-light"
                                    >
                                      <i className="far fa-eye me-2" />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this attendance?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </Fragment>
  );
};

export default Attendance;
